import {
  FRIENZZI_BOT_MENTION_LABEL,
  FRIENZZI_BOT_UID,
} from './profile-mention-helpers';

import type { MentionCandidate } from './post-service';

export function profileMentionLabel(candidate: MentionCandidate) {
  if (candidate.uid === FRIENZZI_BOT_UID && candidate.username) {
    return FRIENZZI_BOT_MENTION_LABEL;
  }

  return `@${candidate.fullName}`;
}
